/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* istanbul ignore file */
import React, { ReactElement } from "react";
import { Paragraph } from "../../components/Paragraph";
import { DefaultHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../components/Heading";
import { Chapter } from "../../components/Chapter";

type OnsAdviesProps = {
  onsAdvies: DefaultHoofdstuk;
  geadviseerdeProducten: DefaultHoofdstuk | null;
};

const OnsAdviesChapter = ({
  onsAdvies,
  geadviseerdeProducten,
}: OnsAdviesProps): ReactElement => {
  return (
    <Chapter>
      <Heading text={onsAdvies.titel!} />
      <Paragraph>{onsAdvies?.paragrafen?.p30500?.inhoud}</Paragraph>
    </Chapter>
  );
};

export default OnsAdviesChapter;
